/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customers_Creation_DisabledInputs */



/**
* | output |
* | --- |
* | "Your account is not enabled for customer creation. Contact oneAI to have it switched on — your existing customers are unaffected." |
*
* @param {Partner_Customers_Creation_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customers_creation_disabled = /** @type {((inputs?: Partner_Customers_Creation_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customers_Creation_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Konto ist nicht für das Anlegen von Kunden freigeschaltet. Wenden Sie sich an oneAI, um es aktivieren zu lassen — Ihre bestehenden Kunden sind davon nicht betroffen.")
	return /** @type {LocalizedString} */ ("Your account is not enabled for customer creation. Contact oneAI to have it switched on — your existing customers are unaffected.")
});